import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  CancelButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { tagKra } from "../../../../../redux/features/appraisalSlice";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import AddKra from "../../../methods/AddKra";

const AddKraUserSpecific = ({ userId, update }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const { kralibraries, loading } = useSelector((state) => state.appraisal);
  const [multipleKraAndWeightage, setMultipleKraAndWeightage] = useState([]);
  const data = {
    search: "",
    type: "kra",
  };
  const handleChange = (event, value) => {
    setSelectedSkills(value);
    // Get the ids of currently selected items
    const selectedIds = value.map((item) => item.appraisal_library_id);

    // Filter out any that are no longer selected
    let updated = multipleKraAndWeightage.filter((item) =>
      selectedIds.includes(item.masterId)
    );

    // Find new items not yet in multipleKraAndWeightage
    const newItems = value
      .filter(
        (item) =>
          !multipleKraAndWeightage.some(
            (existing) => existing.masterId === item.appraisal_library_id
          )
      )
      .map((item) => ({
        kraName: item.appraisal_library_name,
        masterId: item.appraisal_library_id,
        weightage: "",
      }));

    // Combine
    updated = [...updated, ...newItems];
    setMultipleKraAndWeightage(updated);
  };
  // when editing weightage
  const weightageChange = (kraId, value) => {
    setMultipleKraAndWeightage((prev) =>
      prev.map((data) =>
        data.masterId === kraId ? { ...data, weightage:(value===null||value==="")?null: Number(value) } : data
      )
    );
  };

  const handleAddSkill = () => {
    if (multipleKraAndWeightage.length === 0) {
      return enqueueSnackbar("Please select a KRA...!", {
        variant: "error",
      });
    }
    if (
      multipleKraAndWeightage.some((data) => {
        const weight = Number(data.weightage);
        return isNaN(weight) || weight < 0 || weight > 100;
      })
    ) {
      return enqueueSnackbar("Value should be in between 0-100!", {
        variant: "error",
      });
    }
    const data = {
      userId: userId,
      masterDatas: multipleKraAndWeightage.map((obj)=>{
        if(obj.weightage===""){
          return {...obj,weightage:null}
        }else{
          return obj
        }
      }),
    };

    dispatch(tagKra(data)).then((res) => {
      if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        update((prev) => !prev);
        setOpen(false);
        setSelectedSkills([]);
        setMultipleKraAndWeightage([]); // reset after success
      }
    });
  };
  return (
    <GlobalDialog
      title={"Tag KRA"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <Button
          startIcon={<Icon icon="tabler:tag" width="24" height="24" />}
          onClick={() => setOpen(true)}
          size="small"
        >
          Tag KRA
        </Button>
      }
      content={
        <>
          {open ? (
            <Box>
              <Box>
                <Box
                  mb={2}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <AddKra dispatchData={data} />
                </Box>

                <Autocomplete
                  fullWidth
                  multiple
                  options={kralibraries}
                  getOptionLabel={(option) => option.appraisal_library_name}
                  value={selectedSkills}
                  onChange={handleChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select KRA"
                      placeholder="Choose..."
                    />
                  )}
                />
              </Box>

              <Stack gap={1.5} mt={1} p={1}>
                {multipleKraAndWeightage.map((kra, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        fontWeight: 500,
                        minWidth: "150px", // adjust as needed
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {`${kra?.kraName}`}
                    </Typography>

                    <TextField
                      value={kra?.weightage}
                      size="small"
                      type="number"
                      label="Weightage"
                      onChange={(e) =>
                        weightageChange(kra?.masterId, e.target.value)
                      }
                      // onBlur={(e) => {
                      //   if (e.target.value < 0 || e.target.value > 100) {
                      //     weightageChange(kra?.masterId, 0);
                      //   }
                      // }}
                      InputLabelProps={{
                        // shrink: true,
                        sx: {
                          fontSize: "0.7rem", // 👈 customize the size
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "30px",
                          width: "90px",
                        },
                      }}
                    />
                  </Box>
                ))}
              </Stack>
            </Box>
          ) : null}
        </>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <UpdateButton
            disabled={loading}
            size={"small"}
            action={handleAddSkill}
          >
            {loading ? "Please wait..." : "Update"}
          </UpdateButton>
        </>
      }
    />
  );
};

export default AddKraUserSpecific;
